<template>
  <div class="page_box">
    <div class="banner_bg"></div>
    <div class="breadcrumb_box content_box">
      <p>
        您现在的位置：<span @click="backAction">产品中心</span> >
        {{ productInfo.id }}
      </p>
    </div>
    <div class="d_flex justify_content_between content_box">
      <img :src="productInfo.detailSrc" alt="" srcset="" class="img1" />
      <div class="position_relative">
        <h1>{{ productInfo.id }}</h1>
        <p
          v-for="(item, index) in productInfo.descArr"
          :key="index"
          class="desc_item"
        >
          {{ item }}
        </p>
        <p class="message_btn" @click="toAboutUsPage">立即联系</p>
      </div>
    </div>
    <div class="bottom_box content_box">
      <div class="tab_box">
        <p>产品详情</p>
      </div>
      <div class="detail_box">
        <img
          :src="
            productInfo.contentSrc ||
              require('@/assets/product/detail_content.png')
          "
          alt=""
          srcset=""
        />
        <p
          v-for="(item, index) in productInfo.contentArr"
          :key="index"
          class="content_item"
        >
          {{ item }}
        </p>
      </div>
    </div>
    <div class="mt_7 content_box">
      <title-box text="相关推荐"></title-box>
      <div class="d_flex justify_content_between mt_7">
        <div
          v-for="(item, index) in showHotProductList"
          :key="index"
          class="product_item_box"
          @click="productItemClick(item)"
        >
          <img :src="item.listSrc" alt="" />
          <p>{{ item.id }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productList, hotProductList } from "@/utils/const.js";
import TitleBox from "@/components/title.vue";
export default {
  name: "ProductDetail",
  components: {
    TitleBox
  },
  data() {
    return {
      productInfo: {},
      id: ""
    };
  },
  watch: {
    $route: {
      handler() {
        this.id = this.$route.query.id;
        this.productInfo = productList.find(item => item.id === this.id);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    showHotProductList() {
      return hotProductList.map(item => {
        return productList.find(productItem => productItem.id === item);
      });
    }
  },
  methods: {
    toAboutUsPage() {
      this.$router.push("/about-us");
    },
    backAction() {
      this.$router.replace("/product/list");
    },
    productItemClick(item) {
      this.$router.replace("/product/detail?id=" + item.id);
    }
  }
};
</script>

<style scoped lang="scss">
.page_box {
  padding-bottom: 30px;
}
.banner_bg {
  height: 600px;
  background: url("~@/assets/index/banner4.png") no-repeat center top;
  background-size: cover;
}
.breadcrumb_box {
  margin-bottom: 40px;
  margin-top: 50px;
  p {
    font-size: 16px;
    color: #323232;
    span {
      cursor: pointer;
    }
  }
}

.img1 {
  border: 2px solid #f7f7f7;
  margin-right: 46px;
}
h1 {
  font-size: 32px;
  font-weight: 600;
  color: #323232;
}
.desc_item {
  font-size: 16px;
  color: #323232;
  line-height: 30px;
}
.message_btn {
  width: 146px;
  height: 48px;
  background: #fde101;
  border-radius: 6px;
  font-size: 18px;
  color: #323232;
  line-height: 48px;
  text-align: center;
  position: absolute;
  bottom: 0;
  cursor: pointer;
}

.bottom_box {
  border: 1px solid #f7f7f7;
  border-top: none;
  margin-top: 50px;
}
.tab_box {
  height: 60px;
  background: #faf9f7;
  p {
    width: 200px;
    height: 60px;
    background: #ffffff;
    border-top: 4px solid #fbe74e;
    text-align: center;
    line-height: 60px;
    font-size: 20px;
    color: #323232;
    cursor: pointer;
  }
}

.detail_box {
  padding: 50px 30px 50px;
  img {
    margin-bottom: 20px;
  }
  .content_item {
    font-size: 16px;
    font-weight: 500;
    color: #323232;
    line-height: 40px;
  }
}

.product_item_box {
  width: 380px;
  height: 400px;
  background: #ffffff;
  border: 2px solid #f7f7f7;
  margin-top: 40px;
  position: relative;
  box-sizing: content-box;
  p {
    width: 384px;
    height: 50px;
    background: #e7e7e7;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    color: #323232;
    position: absolute;
    bottom: -2px;
    left: -2px;
  }
}

.product_item_box:hover {
  box-shadow: 0px 4px 47px 7px rgba(165, 165, 165, 0.36);
  cursor: pointer;
  p {
    background: #fbe74e;
    font-weight: 600;
  }
}
</style>
